<template>
  <div>
    <list ref="list" :Stage="Stage" :OrderType="orderType" v-if="OrderType === '未下达'">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button type="primary" @click="examineArr" icon="el-icon">批量审批</el-button>
        <!-- <el-button type="primary" v-if="IssueIsApproval" @click="examineArr" icon="el-icon">批量审批</el-button>
        <el-button type="primary" v-if="IssueIsApproval" @click="AbandonmentArr" icon="el-icon">批量弃审</el-button> -->
        <!-- <el-button type="primary" v-if="!IssueIsApproval" @click="onOrderPrint" style="margin-bottom: 5px;" icon="el-icon">下达打印</el-button> -->

        <el-button type="primary" @click="onExport(1)">导出</el-button>
        <!-- <el-button type="primary" v-if="!IssueIsApproval" @click="onOrderRelease" icon="el-icon">工单下达</el-button> -->
        <!-- <el-button type="primary" @click="onProduction(1)">排产汇总查询</el-button>
        <el-button type="primary" @click="onMaterials(1)">工单用料</el-button> -->
        <el-button type="primary" @click="changeWages(1)">修改工价/设备</el-button>
        <el-button type="danger" @click="delRows">删除</el-button>
        <el-button type="primary" v-if="OrderType == '未下达'" @click="openOrder" icon="el-icon-plus">添加工单</el-button>
      </template>
      <template slot="column">
        <el-table-column label="操作" fixed="right" align="center" width="140">
          <template slot-scope="{ row }">
            <!-- <el-button key="btn6" type="text" @click="revokeClose(row)"  v-if="row.Status===5||row.Status === 7" >取消完结</el-button> -->
            <!-- <el-button key="btn2" type="text" @click="unbinding(row)" v-if="row.Status!==5">解绑</el-button> -->
            <!-- <el-button key="btn4" type="text" @click="details(row)">编辑</el-button> -->
            <!-- <el-button key="btn1" type="text" @click="end(row)" :disabled="row.Status === 7||row.Status===5" v-if="row.Status!==5&&row.Status!=7">完结</el-button> -->
            <!-- <el-button key="btn2" type="text" @click="toPrint(row)">打印</el-button> -->
            <!-- <el-button key="btn3" type="text" @click="onDelete(row)">删除</el-button> -->
            <el-button key="btn1" type="text" @click="details(row, 1)">查看</el-button>
            <el-button key="btn2" type="text" @click="onEdit(row)" :disabled="row.isEditBtn">{{ row.isEdit ? '保存' : '编辑' }}</el-button>
            <el-button key="btn3" type="text">{{ row.Status === 3 ? '已审' : '未审' }}</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <list2 ref="list2" :Stage="Stage" :OrderType="orderType" v-if="OrderType === '已下达'">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button type="primary" @click="AbandonmentArr" icon="el-icon">批量弃审</el-button>
        <!-- <el-button type="primary" v-if="IssueIsApproval" @click="examineArr" icon="el-icon">批量审批</el-button> -->
        <!-- <el-button type="primary" v-if="IssueIsApproval" @click="AbandonmentArr" icon="el-icon">批量弃审</el-button> -->
        <el-button type="primary" @click="onExport(2)">导出</el-button>
        <!-- <el-button type="primary" @click="onProduction(2)">排产汇总查询</el-button>
        <el-button type="primary" @click="onMaterials(2)" icon="el-icon">已下达工单用料</el-button> -->
        <el-button type="primary" @click="changeWages(2)">修改工价/设备</el-button>
        <el-button type="primary" @click="onOrderPrint2" style="margin-bottom: 5px" icon="el-icon">批量打印</el-button>
        <!-- <el-button type="primary" v-if="!IssueIsApproval" @click="onOffOrder" icon="el-icon">取消下达</el-button> -->
        <el-button type="danger" @click="onClose">中止</el-button>
      </template>
      <template slot="column">
        <el-table-column label="操作" fixed="right" align="center" width="200">
          <template slot-scope="{ row }">
            <!-- <el-button key="btn6" type="text" @click="revokeClose(row)"  v-if="row.Status===5||row.Status === 7" >取消完结</el-button>
            <el-button key="btn2" type="text" @click="unbinding(row)" v-if="row.Status!==5">解绑</el-button> -->
            <!-- <el-button key="btn4" type="text" @click="details(row)">编辑</el-button> -->
            <!-- <el-button key="btn1" ftype="text" @click="end(row)" :disabled="row.Status === 7||row.Status===5" v-if="row.Status!==5&&row.Status!=7">完结</el-button> -->
            <!-- <el-button key="btn6" type="text" @click="toPrint(row)">打印</el-button> -->
            <el-button key="btn4" type="text" @click="details(row, 2)">查看</el-button>
            <!-- <el-button key="btn5" type="text" @click="onJobBriefing(row)">报工简报</el-button> -->
            <el-button key="btn6" type="text" @click="onStop(row)">{{ row.Status == 8 ? '取消暂停' : '暂停' }}</el-button>
            <el-button key="btn7" type="text" @click="end(row)">完结</el-button>
            <el-button key="btn5" type="text" @click="toPicPrint(row)">打印</el-button>
          </template>
        </el-table-column>
      </template>
    </list2>
    <list3 ref="list3" :Stage="Stage" :OrderType="orderType" v-if="OrderType === '日生产'">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button type="primary" @click="onExport(3)">导出</el-button>
        <!-- <el-button type="primary" @click="onProduction(3)">排产汇总查询</el-button>
        <el-button type="primary" @click="onMaterials(3)" icon="el-icon">已下达日生产工单用料</el-button> -->
        <el-button type="primary" v-if="!IssueIsApproval" @click="onOrderPrint(3)" style="margin-bottom: 5px" icon="el-icon">批量打印</el-button>
        <el-button type="primary" v-if="!IssueIsApproval" @click="onOffOrder(3)" icon="el-icon">取消下达</el-button>
        <el-button type="danger" @click="onClose">中止</el-button>
      </template>
      <template slot="column">
        <el-table-column label="操作" fixed="right" align="center" width="200">
          <template slot-scope="{ row }">
            <el-button :key="Math.random()" type="text" @click="details(row, 3)">查看</el-button>
            <!-- <el-button :key="Math.random()" type="text" @click="onJobBriefing(row, 3)">报工简报</el-button> -->
            <el-button :key="Math.random()" type="text" @click="onStop(row, 3)">{{ row.Status == 8 ? '取消暂停' : '暂停' }}</el-button>
            <el-button :key="Math.random()" type="text" @click="end(row, 3)">完结</el-button>
          </template>
        </el-table-column>
        <!-- <el-table-column label=" " fixed="right" align="center" width="40">
          <template slot-scope="{ row }">
            <div class="my-handle" @click="sortable">
              <div>
                <i class="el-icon-sort"></i>
              </div>
            </div>
          </template>
        </el-table-column> -->
      </template>
    </list3>
    <!-- <div>{{ orderType }}，加工阶段id{{ Stage }}</div> -->
    <div style="display: flex; margin-top: 10px" v-if="false">
      <div style="margin-right: 10px"><el-button type="primary" @click="onGetFutureDailyList(row)">刷新</el-button></div>
      <div>{{ StageName }}日产能：未来七天已下达任务：{{ futureDailyList }}</div>
    </div>
    <release-dialog ref="releaseDialog" :lineData="lineData" @saved="reload" @onClosed="onClosed"></release-dialog>
    <detail-dialog ref="detailDialog" :StageName="StageName" :Stage="Stage"></detail-dialog>
    <edit-dialog ref="editDialog" :StageName="StageName" :Stage="Stage" @saved="reload" @onClosed="onClosed" v-if="hackReset"></edit-dialog>
    <qua-dialog ref="quaDialog" @saved="reload"></qua-dialog>
    <unbinding-dialog ref="unbindingDialog" @select="submit"></unbinding-dialog>
    <job-briefing ref="jobBriefing"></job-briefing>
    <materials-dialog ref="materialsDialog"></materials-dialog>
    <order-dialog ref="orderDialog" :StageName="StageName"></order-dialog>
    <production-dialog ref="productionDialog" :StageName="StageName"></production-dialog>
    <schedule-dialog ref="scheduleDialog" @change="reload2"></schedule-dialog>
  </div>
</template>
<script>
import Sortable from 'sortablejs'
import curdMixins from '@/mixins/trend/curd'
import list from '@/components/production/ticketmanagement/newworkorder/currency/list'
import list2 from '@/components/production/ticketmanagement/newworkorder/currency/list2'
import list3 from '@/components/production/ticketmanagement/newworkorder/currency/list3'
import detailDialog from '@/components/production/ticketmanagement/newworkorder/currency/detailDialog'
import editDialog from '@/components/production/ticketmanagement/newworkorder/currency/editDialog'
import quaDialog from '@/components/production/ticketmanagement/newworkorder/quaDialog'
import unbindingDialog from '@/components/production/ticketmanagement/newworkorder/unbindingDialog'
import releaseDialog from '@/components/production/ticketmanagement/newworkorder/releaseDialog'
import jobBriefing from '@/components/production/ticketmanagement/newworkorder/currency/jobBriefing'
import materialsDialog from '@/components/production/ticketmanagement/newworkorder/currency/materialsDialog'
import orderDialog from '@/components/production/ticketmanagement/newworkorder/currency/orderDialog'
import productionDialog from '@/components/production/ticketmanagement/newworkorder/currency/productionDialog'
import scheduleDialog from '@/components/production/ticketmanagement/injection/scheduleDialog'

export default {
  name: 'workorder',
  mixins: [curdMixins],
  components: {
    list,
    list2,
    list3,
    detailDialog,
    editDialog,
    quaDialog,
    unbindingDialog,
    releaseDialog,
    jobBriefing,
    materialsDialog,
    orderDialog,
    productionDialog,
    scheduleDialog
  },
  data() {
    return {
      api: require('@/api/production/workDoc').default,
      unBindMaterialApi: require('@/api/production/unBindMaterial').default,
      workDocApi: require('@/api/production/workDoc').default,
      optionApi: require('@/api/sy/option').default,
      hackReset: false,
      lineData: [],
      IssueIsApproval: false,
      futureDailyList: [],
      orderType: '未下达',
      IsLoading: true // 页面加载
    }
  },
  props: {
    Stage: {
      type: Number,
      default: 0
    },
    StageName: {
      type: String,
      default: ''
    },
    OrderType: {
      type: String,
      default: '未下达'
    }
  },
  watch: {
    OrderType(v) {
      this.orderType = v
      //this.getFutureDailyList()
    }
  },
  created() {
    this.initProps()
    //this.getFutureDailyList()
    this.optionApi.getWorkDocSetting().then(res => {
      if (res.Code === 0) {
        this.IssueIsApproval = res.Data.IssueIsApproval
      }
    })
  },
  activated() {
    //this.getFutureDailyList()
  },
  methods: {
    reload2(data) {
      if (data.type == 1) {
        this.$refs.list.reload()
      } else if (data.type == 2) {
        this.$refs.list2.reload()
      }
    },
    changeWages(type) {
     let checkedRows
      if (type == 1) {
        checkedRows = this.$refs.list.$refs.list.checkedRows
      } else if (type == 2) {
        checkedRows = this.$refs.list2.$refs.list.checkedRows
      }
      if (checkedRows.length == 0) return this.$message({ type: 'warning', message: '请至少勾选一张单据进行修改' })

      let arr = []
      checkedRows.forEach(item => {
        arr.push(item.WorkDocId)
      })
      let o = {
        WorkDocIds: arr,
        type:type
      }

      this.$refs.scheduleDialog.openEdit(o)
    },
    initProps() {
      this.orderType = this.OrderType
    },
    getFutureDailyList() {
      const params = {
        IsRelease: this.OrderType == '未下达' ? false : true,
        Stage: this.Stage,
        Statuses: [3]
      }
      this.api.GetFutureDaily(params).then(res => {
        if (res.Code === 0) {
          this.futureDailyList = res.Data.map(item => `${item.Key}:${item.Value}`).join(', ')
        } else {
          this.$message.warning(res.Msg)
        }
      })
    },
    onGetFutureDailyList() {
      this.getFutureDailyList()
      this.$message.success('刷新成功')
    },
    onExport(type) {
      var loading = this.$loading({
        lock: true,
        text: '正在导出...',
        spinner: 'el-icon-loading',
        customClass: 'my_loading',
        background: 'rgba(0, 0, 0, 0.3)'
      })

      let queryParams = null
      if (type == 1) {
        queryParams = this.$refs.list.$refs.list.queryParams
      } else if (type == 2) {
        queryParams = this.$refs.list2.$refs.list.queryParams
      } else if (type == 3) {
        queryParams = this.$refs.list3.$refs.list.queryParams
      }
      // this.$refs.list.onExport()
      this.api
        .export({
          ...queryParams,
          IsRelease: this.OrderType == '未下达' ? false : true,
          Stage: this.Stage
        })
        .then(() => {
          loading.close()
        })
    },
    submit(data) {
      console.log('data', data)
      var loading = this.$loading({
        lock: true,
        text: '正在保存...',
        spinner: 'el-icon-loading',
        customClass: 'my_loading',
        background: 'rgba(0, 0, 0, 0.3)'
      })
      this.unBindMaterialApi
        .submit(data)
        .then(res => {
          loading.close()
          if (res.Code === 0) {
            this.$message.success(res.Msg)
          } else {
            this.$message.warning(res.Msg)
          }
        })
        .catch(err => {
          loading.close()
        })
    },
    end(row) {
      this.$refs.quaDialog.openDetails(row)
    },
    unbinding({ WorkDocId }) {
      this.$refs.unbindingDialog.open().then(that => {
        that.getData(WorkDocId)
      })
    },
    revokeClose(row) {
      this.api.revokeClose(row.WorkDocId).then(res => {
        if (res.Code === 0) {
          this.$message.success(res.Msg)
          this.reload()
        } else {
          this.$message.warning(res.Msg)
        }
      })
    },
    examineArr() {
      //checkedRows
      let checkedRows = this.$refs.list.$refs.list.checkedRows
      if (checkedRows.length == 0) return this.$message({ type: 'warning', message: '请至少勾选一张单据进行审批' })
      let el = checkedRows.find(el => el.Status == 3)
      if (el) return this.$message({ type: 'warning', message: '勾选的单据有已审批内容' })
      let Ids = []
      checkedRows.forEach(item => {
        Ids.push(item.WorkDocId)
      })
      this.api.getReview({ Ids: Ids }).then(res => {
        if (res.Code == 0) {
          this.$message.success(res.Msg)
          this.reload()
        } else {
          this.$message.error(res.Msg)
        }
      })
    },
    AbandonmentArr() {
      let checkedRows = this.$refs.list2.$refs.list.checkedRows
      if (checkedRows.length == 0) return this.$message({ type: 'warning', message: '请至少勾选一张单据进行弃审' })
      let el = checkedRows.find(el => el.Status != 3)
      if (el) return this.$message({ type: 'warning', message: '勾选的单据包含未审批内容' })
      let Ids = []
      checkedRows.forEach(item => {
        Ids.push(item.WorkDocId)
      })
      this.api.Back({ Ids: Ids }).then(res => {
        if (res.Code == 0) {
          this.$message.success(res.Msg)
           this.$refs.list2.reload()
        } else {
          this.$message.error(res.Msg)
        }
      })
    },
    onClosed() {
      this.$nextTick(function () {
        // 加载
        this.hackReset = false
      })
    },
    openOrder() {
      this.hackReset = true
      this.$nextTick(function () {
        this.$refs.editDialog.open()
      })
    },
    delRows() {
      this.$refs.list.del()
    },
    onClose() {
      this.$refs.list2.close()
    },
    onStop(row, type) {
      if (type == 3) {
        this.$refs.list3.stop(row)
      } else {
        this.$refs.list2.stop(row)
      }
    },
    details({ WorkDocId }) {
      this.$refs.detailDialog.openDetailsById(WorkDocId)
    },
    toPrint(row) {
      let newpage = this.$router.resolve({
        path: '/workorderPrint?id=' + row.WorkDocId + '&t=' + this.Stage + '&name=' + this.StageName
      })
      window.open(newpage.href, '_blank')
    },
    toPicPrint(row) {
      let path = `/newworkPicPrint2?name=${this.StageName}&ids=${row.WorkDocId}`;
      let newpage = this.$router.resolve({ path });
      window.open(newpage.href, '_blank');
    },
    /** 批量打印 */
    onOrderPrint(type) {
      let checkedRows
      if (type == 3) {
        this.lineData = this.$refs.list3.$refs.list.checkedRows
        checkedRows = this.$refs.list3.$refs.list.checkedRows
      } else {
        this.lineData = this.$refs.list2.$refs.list.checkedRows
        checkedRows = this.$refs.list2.$refs.list.checkedRows
      }
      if (this.lineData.length == 0) return this.$message({ type: 'warning', message: '请至少勾选一张单据' })
      const { TradeUnitName, DpName } = this.lineData.reduce(
        (acc, curr) => {
          acc.TradeUnitName.add(curr.TradeUnitName)
          acc.DpName.add(curr.DpName)
          return acc
        },
        { TradeUnitName: new Set(), DpName: new Set() }
      )
      if (TradeUnitName.size > 1 || DpName.size > 1) {
        return this.$message({ type: 'warning', message: '请选择同一个车间或者同一个加工商' })
      }
      var WorkDocIds = []
      checkedRows.forEach(item => {
        WorkDocIds.push(item.WorkDocId)
      })
      this.toPrint2(WorkDocIds, type)
    },
    onOrderPrint2() {
      let checkedRows = this.$refs.list2.$refs.list.checkedRows;
      if(checkedRows.length) {
        let ids = checkedRows.map(x => {return x.WorkDocId});
        let path = `/newworkPicPrint2?name=${this.StageName}&ids=${ids.join(",")}`;
        let newpage = this.$router.resolve({ path });
        window.open(newpage.href, '_blank');
      } else this.$message({ type: 'warning', message: '请至少勾选一张单据' });
    },
    toPrint1(ids) {
      let newpage = this.$router.resolve({
        path: '/workorderPrint1?ids=' + ids + '&t=' + this.Stage + '&name=' + this.StageName
      })
      window.open(newpage.href, '_blank')
    },
    toPrint2(ids, type) {
      if (type == 3) {
        let DailyProduction
        if (this.$refs.list3.$children[0].queryParams.DailyProduction) {
          if (this.$refs.list3.$children[0].queryParams.DailyProduction == 1) {
            DailyProduction = '今天'
          } else if (this.$refs.list3.$children[0].queryParams.DailyProduction == 2) {
            DailyProduction = '明天'
          } else if (this.$refs.list3.$children[0].queryParams.DailyProduction == 3) {
            DailyProduction = '后天'
          }
        }
        let newpage = this.$router.resolve({
          path: '/workorderPrint2?ids=' + ids + '&t=' + this.Stage + '&name=' + this.StageName + '&DailyProduction=' + DailyProduction
        })
        window.open(newpage.href, '_blank')
      } else {
        let newpage = this.$router.resolve({
          path: '/workorderPrint2?ids=' + ids + '&t=' + this.Stage + '&name=' + this.StageName
        })
        window.open(newpage.href, '_blank')
      }
    },
    /** 第一版工单下达 */
    // onOrderRelease(){
    //   this.lineData = this.$refs.list.$refs.list.checkedRows
    //   if(this.lineData.length==0)return  this.$message({type: 'warning', message: '请至少勾选一张单据'})
    //   this.$refs.releaseDialog.open()
    // },
    /** 第二版工单下达 */
    // onOrderRelease() {
    //   this.lineData = this.$refs.list.$refs.list.checkedRows
    //   const WorkDocIds = []
    //   this.lineData.forEach(item => {
    //     WorkDocIds.push(item.WorkDocId)
    //   })
    //   if (this.lineData.length == 0) return this.$message({ type: 'warning', message: '请至少勾选一张单据' })
    //   this.$confirm("确定下达这些记录?", "提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     type: "warning",
    //   }).then(() => {
    //     this.workDocApi.releaseReview({ WorkDocIds }).then(res => {
    //       if (res.Code == 0) {
    //         this.$message.success("下达成功");
    //         this.reload();
    //       } else {
    //         this.$message.warning(res.Msg);
    //         this.reload();
    //       }
    //     })
    //   });
    // },
    /** 第三版工单下达 */
    onOrderRelease() {
      this.lineData = this.$refs.list.$refs.list.checkedRows
      const WorkDocIds = []
      this.lineData.forEach(item => {
        WorkDocIds.push(item.WorkDocId)
      })
      if (this.lineData.length == 0) return this.$message({ type: 'warning', message: '请至少勾选一张单据' })
      this.$refs.orderDialog.openDetails(WorkDocIds)
    },
    // 排产汇总查询
    onProduction() {
      this.$refs.productionDialog.openDetails()
    },
    /** 取消下达 */
    onOffOrder(type) {
      let checkedRows
      if (type == 3) {
        this.lineData = this.$refs.list3.$refs.list.checkedRows
        checkedRows = this.$refs.list3.$refs.list.checkedRows
      } else {
        this.lineData = this.$refs.list2.$refs.list.checkedRows
        checkedRows = this.$refs.list2.$refs.list.checkedRows
      }
      if (this.lineData.length == 0) return this.$message({ type: 'warning', message: '请至少勾选一张单据' })
      // 判断每个对象的ReleaseDocNo属性值是否一致
      var WorkDocIds = []
      let isSameReleaseDocNo = checkedRows.every(item => item.ReleaseDocNo !== null && item.ReleaseDocNo !== '' && item.ReleaseDocNo === checkedRows[0].ReleaseDocNo)
      checkedRows.forEach(item => {
        WorkDocIds.push(item.WorkDocId)
      })
      if (isSameReleaseDocNo) {
        this.$confirm('确认取消下达吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.workDocApi.releaseCancel({ WorkDocIds: WorkDocIds }).then(res => {
            if (res.Code == 0) {
              this.$message.success('取消下达成功')
              this.$refs.list2.reload()
            } else {
              this.$message.warning(res.Msg)
              this.$refs.list2.reload()
            }
          })
        })
      } else {
        this.$message.warning('请选择已下达工单且不同下达号不能一同取消！')
      }
    },
    /** 未下达 编辑 */
    onEdit(row) {
      if (row.isEdit) {
        console.log('保存')
        if (!row.StartTime) {
          return this.$message.warning('请选择开工日期')
        }
        if (!row.EndTime) {
          return this.$message.warning('请选择完工日期')
        }
        // if (!row.DailyProduction) {
        //   return this.$message.warning('请输入日完成主数量')
        // }
        if (!row.PickingWarehouseId) {
          return this.$message.warning('请选择预入仓')
        }
        /** 0-自制 1委外 若自制 */
        if (row.ProductionType == 0) {
          if (!row.DpId) {
            return this.$message.warning('请选择生产车间')
          }
        } else {
          if (!row.ProductionDpId) {
            return this.$message.warning('请选择加工商')
          }
        }
        this.$set(row, 'isEdit', false)
        const params = {
          WorkDocIds: [row.WorkDocId],
          StartTime: row.StartTime, //开工日期
          EndTime: row.EndTime, //完工日期
          //DailyProduction: row.DailyProduction, //日完成主数量
          DpId: row.DpId, //生产车间
          ProductionDpId: row.ProductionDpId, //加工商
          PickingWarehouseId: row.PickingWarehouseId, //预入仓
          ReleaseRemark: row.ReleaseRemark, //下达备注
          ReleaseTime: null, //预计完成时间
          PositionId: row.PositionId //存放地点
        }
        this.workDocApi.editSave(params).then(res => {
          if (res.Code == 0) {
            this.$message.success('保存成功')
            this.$refs.list.reload()
          } else {
            this.$message.warning(res.Msg)
            this.$refs.list.reload()
          }
        })
      } else {
        console.log('编辑')
        this.$refs.list.$refs.list.data.forEach(item => {
          this.$set(item, 'isEditBtn', true)
        })
        this.$set(row, 'isEdit', true)
        this.$set(row, 'isEditBtn', false)
      }
    },
    /** 简报 */
    onJobBriefing({ WorkDocId }) {
      this.$refs.jobBriefing.openDetails(WorkDocId)
    },
    /** 排序 */
    sortable() {
      this.$nextTick(() => {
        var el = this.$refs.list3.$refs.list.$refs.table.$el.querySelectorAll('.el-table__body-wrapper .el-table__body tbody')
        let that = this
        let options = {
          animation: 300,
          // handle:".my-handle",
          onEnd: function (evt) {
            const oldIndex = evt.oldIndex
            const newIndex = evt.newIndex

            const params = {
              WorkDocIds: [that.$refs.list3.$refs.list.$refs.table.data[oldIndex].WorkDocId],
              Sn: newIndex + 1
            }
            // that.api.editSort(params).then((res) => {
            //   if (res.Code === 0) {
            //     that.$message.success(res.Msg)
            //     that.$refs.list3.reload();
            //   } else {
            //     that.$message.warning(res.Msg)
            //     that.$refs.list3.reload();
            //   }
            // });
          }
        }
        Sortable.create(el, options)
      })
    },
    /** 已下达工单用料 */
    onMaterials(type) {
      var checkedRows
      if (type == 1) {
        checkedRows = this.$refs.list.$refs.list.checkedRows
      } else if (type == 2) {
        checkedRows = this.$refs.list2.$refs.list.checkedRows
      } else if (type == 3) {
        checkedRows = this.$refs.list3.$refs.list.checkedRows
      }
      var WorkDocIds = []
      checkedRows.forEach(item => {
        WorkDocIds.push(item.WorkDocId)
      })
      if (WorkDocIds.length == 0) {
        return this.$message({ type: 'warning', message: '请至少勾选一张单据' })
      }
      this.$refs.materialsDialog.openDetails(WorkDocIds)
    }
  }
}
</script>
<style lang="scss" scoped>
.count {
  margin-right: 15px;
  font-size: 14px;
  color: red;
  display: inline-block;
}
</style>